import React, { useState } from 'react';

export const ImageWithFallback = ({ src, alt, fallbackSrc, className }) => {
    const combinedClassName = `${className} ${!src ? 'bg-[#6446C3]' : ''}`;

    return <img className={combinedClassName} src={src || fallbackSrc} alt={alt} />;
};